import { render, staticRenderFns } from "./ThumbnailAutomaticGenerator.vue?vue&type=template&id=50172c80&scoped=true"
import script from "./ThumbnailAutomaticGenerator.vue?vue&type=script&lang=ts"
export * from "./ThumbnailAutomaticGenerator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50172c80",
  null
  
)

export default component.exports